import { api } from '@/lib/api/axios';

export interface UserNotificationPreferences {
  webappEnabled: boolean;
  pushEnabled: boolean;
  whatsappEnabled: boolean;
  smsEnabled: boolean;
}

export type UserNotificationPreferencesUpdate = Partial<UserNotificationPreferences>;

export const userNotificationPreferencesQueryKey = ['users', 'me', 'notification-preferences'] as const;

export const UserNotificationPreferencesService = {
  get: async () => {
    const { data } = await api.get<UserNotificationPreferences>('/users/me/notification-preferences');

    return data;
  },

  update: async (preferences: UserNotificationPreferencesUpdate) => {
    const { data } = await api.patch<UserNotificationPreferences>('/users/me/notification-preferences', preferences);

    return data;
  },
};
